export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:finish', () => {
    // @ts-ignore
    if (process.client && window.__NUXT__SCROLL_POSITION) {
      // @ts-ignore
      const { left, top, behavior } = window.__NUXT__SCROLL_POSITION
      window.scrollTo({ left, top, behavior })
    }
  })
})